import theme from '../../theme/theme';

const {
  colors: { blue_purple_button, black_text, end_trip, white_text, divider },
} = theme;

const styles = {
  container: {
    display: 'flex',
    flex: '1',
    minHeight: '4.625em',
  },

  button__wrapper: {
    display: 'flex',
    flex: 1,
    borderRadius: '0',
    minHeight: '4.625em',
    borderTop: `0.063em solid ${divider}`,
  },

  button__text: {
    fontSize: '1.8em',
    textTransform: 'capitalize',
    fontFamily: 'semibold',
    color: black_text,
  },

  button__blue: {
    display: 'flex',
    flex: 1,
    borderRadius: '0',
    background: blue_purple_button,
    minHeight: '4.625em',
  },

  footer: {
    display: 'flex',
    flex: 1,
    width: '100%',
    position: 'absolute',
    bottom: 0,
    minHeight: '4.625em',
  },

  divider: {
    borderRight: `0.063em solid ${divider}`,
    height: '3.250em',
    marginTop: '.6em',
  },

  endTrip: {
    display: 'flex',
    flex: 1,
    borderRadius: '0',
    background: end_trip,
    minHeight: '4.625em',
  },

  button__text__white: {
    fontSize: '1.8em',
    textTransform: 'capitalize',
    fontFamily: 'semibold',
    color: white_text,
  },

  action__button: {
    display: 'flex',
    flex: 1,
    fontSize: '1.8em',
    borderRadius: '0',
    borderLeft: '0',
    borderRight: '0',
    textTransform: 'capitalize',
    fontFamily: 'semibold',
  },

  share__button: {
    display: 'flex',
    flex: 1,
    fontSize: '1.8em',
    borderRadius: '0',
    textTransform: 'capitalize',
    fontFamily: 'semibold',
  },
};

export default styles;
